<template>
	<side-window :tabs="tabs" :active="active" class="contact" title="Enhed" @pop="$emit('pop')" @close="$emit('close')" @tabSelect="tabSelect">
		<div v-if="!id || (form && id)">
			<form-grid-layout>
				<div v-show="active == 'details'">
					<string-view label="Navn" v-model="entity.name" />
				</div>
				<div v-show="active == 'details'">
					<select-view :options="unit_types" label="Type" v-model="entity.unit_type_id" optionLabelName="name" optionValueName="id" />
				</div>
				<div v-show="active == 'details'">
					<contact-select-view v-model="entity._embdedded" label="Kunde" :optional="true" @select="selectCustomer" />
				</div>
			</form-grid-layout>
		</div>
		<div v-if="!id" slot="footer">
			<button-view label="Opret" @click="create" />
		</div>
		<div v-if="form && id" slot="footer">
			<button-view label="Gem" @click="update" />
		</div>
	</side-window>
</template>

<script>
	import TextView from '../views/TextView';
	import StringView from '../views/StringView';
	import ContactSelectView from '../views/ContactSelectView';

	import merge from '../functions/merge'

	export default {
		data() {
			return {
				entity: {
					name: null,
					unit_type_id: null,
					contact_id: null,
					_embedded: {
						contact: {
							name: '',
							address: {
								address: 	'',
								zip: 		'',
								city: 		'',
								country: 	''
							},
							phone: '',
							email: '',
							numbers: {
								vat:		'',
								ean:		''
							}
						}
					}
				},
				active: 'details',
				unit_types: [],
				locations: []
			};
		},
		components: {
			'TextView': TextView,
			'StringView': StringView,
			'ContactSelectView': ContactSelectView
		},
		computed: {
			_roles() {
				var r = {};
				var role;
				var props;
				var prop;

				for (var i = 0; i < this.roles.length; ++i) {
					role = this.roles[i];
					props = {};
					
					for (var j = 0; j < role.props.length; ++j) {
						prop = role.props[j];
						props[prop.name] = prop.default;
					}

					r[role.name] = {
						enabled: false,
						props: props
					};
				}

				return r;
			},
			tabs: function () {
				if (this.id) {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						}
						/*{
							name: 'contacts',
							label: 'Contacts'
						}*/
					];
				} else {
					return [
						{
							name: 'details',
							label: 'Detaljer'
						}
					];
				}
			}
		},
		props: {
			id: Number,
			form: Boolean,
			onCreate: {
				type: Function,
				default: function () {}
			},
			onUpdate: {
				type: Function,
				default: function () {}
			},
			onChange: {
				type: Function,
				default: function () {}
			}
		},
		methods: {
			selectCustomer(obj) {
				
				this.numbers = [];

				this.setNumbers(obj);

				this.entity = merge(this.entity, {
					_embedded: {
						customer: {
							name: obj.name,
							address: {
								address: 	obj.address,
								zip: 		obj.zip,
								city: 		obj.city,
								country: 	obj.country
							},
							phone: obj.phone,
							email: obj.email,
							numbers: {
								vat:		obj.roles.business ? obj.roles.business.vat : '',
								ean:		obj.roles.business ? obj.roles.business.ean : ''
							}
						}
					}
				});
			},
			invoiceSelect(name, id, label) {
				
				
				

				this.input(name, id);
			},
			tabSelect(name, tabName) {
				
				this.active = tabName;
			},
			create() {
				var win = this;

				
				

				this.axios
					.post('/warehouse/units/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});		
			},
			update() {
				
				

				var win = this;

				this.axios
					.put('/warehouse/units/' + this.id + '/', this.entity)
					.then(function (r) {
						

						if (r.status >= 200 && r.status < 300) {
							win.onCreate(r.data);
							win.onChange(r.data);
							win.$store.state.windowStack.pop();
						}

						
					}, function (err) {
						
						
						var r = err.response;

						if (r.status == 422) {
							alert(r.data);
						} else {
							alert('Server Error');
						}
					});	
			},
			input(name, value) {
				this.entity[name] = value;
			}
		},
		mounted: function() {
			
			

			var self = this;

			if (this.id) {
				this.axios
					.get('/warehouse/units/' + this.id + '/')
					.then(function (r) {
						self.entity = merge(self.entity, r.data);
						self.entity.roles = {...self._roles, ...self.entity.roles};

						
					});
			}

			this.axios
				.get('/warehouse/units/types/')
				.then(function (r) {
					self.unit_types = r.data._items;
				});

			this.axios
				.get('/warehouse/locations/')
				.then(function (r) {
					self.locations = r.data._items;
				});
		}
	}
</script>

<style lang="scss">
	
</style>
